import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { sliceArray } from "../../core/helpers";
import Tooltip from "../Tooltip/Tooltip";
import './ChartTable.styles.scss';

function ChartTable({ data = [], eventName = '', title = '', subtitle = '', columnsCount = 1, hasTooltips = false }) {

    const [activeTooltipIndex, setActiveTooltipIndex] = useState(null);

    const columns = sliceArray(data, Math.ceil(data.length / columnsCount));

    return (
        <div className="chart-table">
            <div className="chart-table__head">
                <div className="chart-table__title">{title}</div>
                <div className="chart-table__subtitle">{subtitle}</div>
            </div>
            <div className="chart-table__body">
                {columns.map((column, inx) => (
                    <div key={inx} className="chart-table__column">
                        {column.map((item, itemInx) => {

                            const title = {
                                component: 'div',
                                props: {
                                    className: 'chart-table__name',
                                }
                            };

                            if (item.link) {
                                title.props.to = item.link;
                                title.component = Link;
                            }

                            return (
                                <div
                                    key={itemInx}
                                    className={`chart-table__row ${hasTooltips ? 'chart-table__row--hasTooltips' : ''}`}
                                    onMouseOver={() => hasTooltips && setActiveTooltipIndex(itemInx)}
                                    onMouseOut={() => hasTooltips && setActiveTooltipIndex(null)}
                                >
                                    <div
                                        className="chart-table__cell"
                                    >
                                        {hasTooltips && (
                                            <Tooltip isShown={activeTooltipIndex === itemInx}>
                                                <span>
                                                    {item.name} is {(item.value / 100).toFixed(2)} more commonly associated with {eventName} than it is in general across all eating events
                                                </span>
                                            </Tooltip>
                                        )}
                                        <title.component {...title.props}>
                                            {item.name}
                                        </title.component>
                                    </div>
                                    <div className="chart-table__cell">{item.value}</div>
                                </div>
                            )
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ChartTable;